import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import actions from './actions'
import auth from './auth'
import carereceiver from './booking-funnel/carereceiver'
import payment from './booking-funnel/payment'
import postcode from './booking-funnel/postcode'
import registration from './booking-funnel/registration'
import scheduling from './booking-funnel/scheduling'
import services from './booking-funnel/services'
import status from './booking-funnel/status'
import success from './booking-funnel/success'
import bookings from './bookings'
import definitions from './defintions'
import family from './family'
import getters from './getters'
import googleOptimize from './googleOptimize'
import mutations from './mutations'
import mycaregivers from './mycaregivers'
import promotions from './promotions'
import paymentMethods from './paymentMethods'
import { RootStateProps } from './types'
import ui from './ui'
import user from './user'

Vue.use(Vuex)

const store: StoreOptions<RootStateProps> = {
  state: {
    translations: {},
    chosenLanguage: 'de',
  },
  mutations,
  actions,
  getters,
  modules: {
    services,
    carereceiver,
    scheduling,
    payment,
    postcode,
    registration,
    success,
    auth,
    mycaregivers,
    status,
    ui,
    user,
    family,
    googleOptimize,
    definitions,
    promotions,
    bookings,
    paymentMethods,
  },
}

export default new Vuex.Store(store)
